import React from "react";

const isClosed = (postalCode, completedStatus) => {
  return !!postalCode && !!completedStatus;
};
const RestaurantHead = ({
  completedStatus,
  addedFavorite,
  url,
  getPictureUrl,
  handleHistoryBack,
  handleToggleFavorites,
  postalCode
}) => {
  const closed = isClosed(postalCode, completedStatus);
  return (
    <div
      className={`head ${(closed && "closed") || ""}`}
      style={{
        background: `url(${getPictureUrl(url, 1400, 550)}) center no-repeat`,
        backgroundSize: "100%"
      }}
    >
      {(closed && (
        <div className="rest-offline splitted">{completedStatus}</div>
      )) || <noscript />}

      <div className="button d-flex justify-content-between align-items-centerc">
        <a className="cursor-pointer" onClick={handleHistoryBack}>
          <icon className="icon icon-back-white" />
        </a>
        <a className="cursor-pointer" onClick={handleToggleFavorites}>
          <icon
            className={`icon icon-favorite-${(addedFavorite && "add") ||
              "remove"}`}
          />
        </a>
      </div>
    </div>
  );
};

export default RestaurantHead;
